import store from '../../core/store';

export const updateOverlay = ({ fabricOverlay, viewer }) => {
  return store.dispatch({
    type: 'canvas_editor/UPDATE_OVERLAY',
    fabricOverlay,
    viewer,
  });
};

export const updateTool = ({ tool }) => {
  return store.dispatch({
    type: 'canvas_editor/UPDATE_TOOL',
    tool,
  });
};

export const updateColor = (color) => {
  return store.dispatch({
    type: 'canvas_editor/UPDATE_COLOR',
    color,
  });
};

export const updateThickness = (thickness) => {
  return store.dispatch({
    type: 'canvas_editor/UPDATE_THICKNESS',
    thickness,
  });
};

export const setActiveObject = (object) => {
  return store.dispatch({
    type: 'canvas_editor/SET_ACTIVE_OBJECT',
    object,
  });
};

export const setToolbarOptionsPanel = (options_panel) => {
  return store.dispatch({
    type: 'canvas_editor/SET_TOOLBAR_OPTIONS_PANEL',
    options_panel,
  });
};

export const setCursorTooltip = (text) => {
  return store.dispatch({
    type: 'canvas_editor/SET_CURSOR_TOOLTIP',
    text,
  });
};

// NEW ACTIONS FOR MULTI-CANVAS SUPPORT

export const registerCanvas = (pageNumber, canvas) => {
  return store.dispatch({
    type: 'canvas_editor/REGISTER_CANVAS',
    payload: { pageNumber, canvas },
  });
};

export const unregisterCanvas = (pageNumber) => {
  return store.dispatch({
    type: 'canvas_editor/UNREGISTER_CANVAS',
    payload: { pageNumber },
  });
};

export const setActivePage = (pageNumber) => {
  return store.dispatch({
    type: 'canvas_editor/SET_ACTIVE_PAGE',
    payload: pageNumber,
  });
};

export const clearAllCanvases = () => {
  return store.dispatch({
    type: 'canvas_editor/CLEAR_ALL_CANVASES',
  });
};

export const getCanvas = (state, pageNumber) =>
  state.canvas_editor.fabricCanvases[pageNumber] || null;
export const getActiveCanvas = (state) =>
  state.canvas_editor.activePage
    ? state.canvas_editor.fabricCanvases[state.canvas_editor.activePage]
    : null;
